import type { CityConfig } from "../city-template/types";

export const lexingtonParkConfig: CityConfig = {
  city: "Lexington Park",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "lexington-park",
  route: "/cities/lexington-park",
  title: "Emergency Passport Lexington Park, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Lexington Park, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Lexington Park, NAS Patuxent River, California, and St. Mary's County. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Lexington Park, MD",
  heroSubtitle: "Lexington Park residents — from Naval Air Station Patuxent River families to Southern Maryland waterfront communities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving St. Mary's County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Waterfront%20community%20view%20in%20Southern%20Maryland%20with%20Chesapeake%20Bay%20shoreline%2C%20small%20boat%20marina%2C%20modern%20suburban%20homes%2C%20green%20lawns%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20coastal%20photography%2C%20no%20visible%20text%20or%20people%2C%20blue%20water%20and%20green%20trees%20with%20warm%20earth%20tones&width=1800&height=700&seq=lexington-park-hero-001&orientation=landscape",
  heroImageAlt: "Chesapeake Bay shoreline view of Lexington Park Maryland with marina and waterfront homes",
  geoPosition: "38.2579;-76.4538",
  geoPlacename: "Lexington Park, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 75–90 minutes from Lexington Park via MD-4 and I-495",
  },
  nearbyCitiesZips: [
    { name: "Lexington Park", zips: "20653" },
    { name: "California", zips: "20619" },
    { name: "Leonardtown", zips: "20650" },
    { name: "Great Mills", zips: "20634" },
    { name: "Mechanicsville", zips: "20659" },
    { name: "St. Mary's City", zips: "20686" },
    { name: "Ridge", zips: "20680" },
    { name: "Park Hall", zips: "20667" },
    { name: "Piney Point", zips: "20674" },
    { name: "Dameron", zips: "20628" },
    { name: "Tall Timbers", zips: "20690" },
    { name: "Waldorf", zips: "20601, 20602, 20603, 20604" },
    { name: "La Plata", zips: "20646" },
    { name: "Prince Frederick", zips: "20678" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Lexington Park and St. Mary's County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-anchor-line", title: "Naval Base Proximity", desc: "Serving NAS Patuxent River military families and defense contractors" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no long drive to DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Waldorf, MD", route: "/cities/waldorf" },
    { name: "Emergency passport help in La Plata, MD", route: "/cities/la-plata" },
    { name: "Urgent passport services in Maryland", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lexington Park, Maryland remotely via secure registered courier. We do not have a walk-in office in Lexington Park — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Lexington Park travelers without the long drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Lexington Park, California, Leonardtown, Great Mills, and greater St. Mary's County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Lexington Park area and St. Mary's County. From the Naval Air Station Patuxent River community to the waterfront neighborhoods along the Chesapeake Bay, from the historic town of Leonardtown to the growing suburban areas of California and Great Mills — we serve all of Southern Maryland's communities.",
  nearbyCitiesIntro: "We serve Lexington Park and nearby communities including California, Leonardtown, Great Mills, Mechanicsville, St. Mary's City, Ridge, Park Hall, Piney Point, Dameron, and Tall Timbers. We also serve Charles County residents in Waldorf and La Plata.",
  howItWorksIntro: "Most Lexington Park travelers complete everything online and ship documents overnight. No need to drive 75–90 minutes to downtown DC through heavy traffic.",
  mistakesIntro: "Lexington Park is a military community with a mix of naval families, defense contractors, and Southern Maryland residents. Here are the most common passport mistakes we see from Lexington Park travelers.",
  testimonialsIntro: "Lexington Park travelers — from NAS Patuxent River families to waterfront residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Lexington Park, MD? Here are the most common ones we hear from St. Mary's County travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (MD Vital Statistics)", url: "https://health.maryland.gov/vsa/", desc: "Maryland Department of Health — Vital Statistics Administration for birth and death certificates statewide" },
    { label: "Marriage Licenses (St. Mary's County Clerk)", url: "https://www.stmarysmd.com/", desc: "St. Mary's County Circuit Court Clerk for Lexington Park area" },
    { label: "Divorce Decrees (St. Mary's County Circuit Court)", url: "https://www.mdcourts.gov/circuit/stmarys", desc: "St. Mary's County Circuit Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Maryland vital records online via VitalChek" },
  ],
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for military and defense travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 75–90 min to downtown DC", "Full day commitment — long drive back and forth"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Lexington Park travelers with immediate departure needs — as fast as 24 hours. Perfect for military deployments, naval travel, and last-minute trips.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Military and naval travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Lexington Park adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Lexington Park address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Lexington Park residents and families — including military spouses and new families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Lexington Park residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Lexington Park families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Lexington Park residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Lexington Park MD", description: "Urgent passport processing for Lexington Park Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Lexington Park MD", description: "Fast passport renewal for Lexington Park Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Lexington Park MD", description: "New passport application services for Lexington Park Maryland residents applying for their first passport." },
    { name: "Child Passport Lexington Park MD", description: "Minor passport services for Lexington Park Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Cmdr. Sarah M.",
      location: "NAS Patuxent River, MD",
      rating: 5,
      text: "Last-minute overseas assignment with 3 days notice. Fast Passport Center had my updated passport in 36 hours. They understand the urgency of military travel better than anyone.",
      service: "Emergency Passport",
    },
    {
      name: "Michael D.",
      location: "Lexington Park, MD",
      rating: 5,
      text: "Family cruise to the Caribbean with 10 days notice. Four passports processed in under a week. We shipped from the Lexington Park UPS Store and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jennifer L.",
      location: "California, MD",
      rating: 5,
      text: "Business trip to Germany with 5 days notice. Fast Passport Center had my renewed passport ready in 2 days. No driving to DC — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas R.",
      location: "Leonardtown, MD",
      rating: 5,
      text: "Last-minute family trip to visit relatives in Ireland. They walked us through the child passport requirements and had everything ready in 5 days. Excellent service for families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "lexington-park-1",
      name: "Lexington Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "46840 S Shangri-la Dr",
      city: "Lexington Park",
      state: "MD",
      zip: "20653",
      phone: "(301) 863-8300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Lexington Park, near the commercial district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lexington Park acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient for NAS Patuxent River families.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-park-2",
      name: "Leonardtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22620 Washington St",
      city: "Leonardtown",
      state: "MD",
      zip: "20650",
      phone: "(301) 475-3841",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Leonardtown, approximately 10 miles north of Lexington Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Leonardtown and northern St. Mary's County residents. Good alternative when Lexington Park appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-park-3",
      name: "California Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22740 Three Notch Rd",
      city: "California",
      state: "MD",
      zip: "20619",
      phone: "(301) 862-4400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "California, approximately 3 miles north of Lexington Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves California and northern St. Mary's County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-park-4",
      name: "Great Mills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21130 Great Mills Rd",
      city: "Lexington Park",
      state: "MD",
      zip: "20653",
      phone: "(301) 863-4300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Great Mills, approximately 3 miles west of Lexington Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Great Mills and western St. Mary's County residents. Good alternative for NAS Patuxent River families.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-park-5",
      name: "St. Mary's County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "41605 Court House Dr",
      city: "Leonardtown",
      state: "MD",
      zip: "20650",
      phone: "(301) 475-4567",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Leonardtown, approximately 10 miles north of Lexington Park",
      website: "https://www.stmarysmd.com/",
      websiteLabel: "St. Mary's County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Serving all St. Mary's County residents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 75–90 min drive to downtown DC", fpc: "No — ship from Lexington Park" },
    { feature: "Military Travel Support", agency: "No flexibility for deployment needs", fpc: "Yes — we handle naval cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Lexington Park's busy military families often discover passport needs just weeks before deployment or departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Lexington Park sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Lexington Park and St. Mary's County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Lexington Park Post Office appointments fill up fast, especially during PCS season and summer travel. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Lexington Park residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Lexington Park, California, or Leonardtown." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Three Notch Rd or in downtown Leonardtown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lexington Park address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Lexington Park, MD?", a: "Fast Passport Center offers emergency passport processing in Lexington Park, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (75–90 minutes from Lexington Park) — without you needing to make the long drive or fight Beltway traffic." },
    { q: "Does Lexington Park have its own passport agency?", a: "No — neither Lexington Park nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 75–90 minutes from Lexington Park via MD-4 and I-495. Fast Passport Center's courier service means Lexington Park residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live at NAS Patuxent River?", a: "Absolutely. Fast Passport Center serves all of the Lexington Park area including NAS Patuxent River, California, Leonardtown, and Great Mills. We also serve St. Mary's City and Mechanicsville residents. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Lexington Park, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Lexington Park travelers use for international flights?", a: "Most Lexington Park residents fly internationally through Reagan National (DCA), approximately 75–90 minutes north via MD-4 and I-495. Dulles International (IAD) is 80–95 minutes north. Baltimore-Washington International (BWI) is 75–90 minutes northeast. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Lexington Park?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Lexington Park, California, Leonardtown, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Lexington Park?", a: "The Lexington Park Post Office at 46840 S Shangri-la Dr is the primary downtown acceptance facility. The California Post Office at 22740 Three Notch Rd serves northern residents. The Leonardtown Post Office at 22620 Washington St serves northern St. Mary's County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Lexington Park residents should plan ahead, especially for military deployments and PCS moves." },
  ],
  photoLocations: [
    { name: "Walgreens — Lexington Park", address: "22520 Three Notch Rd, California, MD 20619", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Lexington Park", address: "21700 Great Mills Rd, Lexington Park, MD 20653", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — California", address: "22740 Three Notch Rd, California, MD 20619", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Leonardtown", address: "22540 Washington St, Leonardtown, MD 20650", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Lexington Park", address: "21801 Three Notch Rd, Lexington Park, MD 20653", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves St. Mary's County and Southern Maryland. REAL ID processing available.", featured: true },
    { name: "MVA — Prince Frederick", address: "200 Duke St, Prince Frederick, MD 20678", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Calvert County and Southern Maryland. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "75–90 minutes from Lexington Park via MD-4 and I-495",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Primary airport for Lexington Park travelers. Direct flights to major domestic hubs and some international destinations.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: true,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "75–90 minutes from Lexington Park via MD-4 and I-495 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative for Southwest Airlines domestic connections and some Caribbean destinations.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "80–95 minutes from Lexington Park via MD-4 and I-495",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights. Direct flights to London, Frankfurt, and major European hubs.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};